﻿import compareDesc from 'date-fns/compareDesc';

export function generateDummyArray(numberOfElements: number): number[] {
    return [...Array(numberOfElements).keys()];
}

export function descendingOnDate(firstLinkInfo, secondLinkInfo): number {
    return compareDesc(
        new Date(firstLinkInfo.linksSentTime),
        new Date(secondLinkInfo.linksSentTime)
    );
}
